import { useMemo } from 'react';
import { Filters, Platform, PlatformSlug } from '~/screens/MyAgency/types';

const PlatformSlugMap: Record<Platform, PlatformSlug> = {
  instagram: 'IG',
  tiktok: 'TT',
  youtube: 'YT',
  snapchat: 'SC',
};

const VALID_PLATFORMS: Platform[] = [
  'instagram',
  'tiktok',
  'youtube',
  'snapchat',
];

const isValidFilter = (filter: any): filter is Filters => {
  return (
    filter &&
    typeof filter === 'object' &&
    typeof filter.platform === 'string' &&
    VALID_PLATFORMS.includes(filter.platform) &&
    typeof filter.filterType === 'string' &&
    filter.filterType.length > 0 &&
    filter.value !== undefined &&
    filter.value !== null
  );
};

export interface GroupedFilters extends Filters {
  platformSlug: string;
  valueLowerCase: string;
  criteria?: number | string;
}

const useGroupFilters = (appliedFilters: Filters[]): GroupedFilters[] => {
  const appliedFiltersGrouped = useMemo(() => {
    if (!Array.isArray(appliedFilters)) {
      return [];
    }

    return appliedFilters
      .filter(
        (filter: any) =>
          isValidFilter(filter) && !filter.filterType.includes('Criteria'),
      )
      .map((filter) => {
        try {
          const criteriaObj = appliedFilters.find(
            (f) =>
              isValidFilter(f) &&
              f.filterType === `${filter.filterType}Criteria` &&
              f.platform === filter.platform,
          );

          const platformSlug = PlatformSlugMap[filter.platform as Platform];
          if (!platformSlug) {
            return null;
          }

          const valueString =
            filter.value && typeof filter.value === 'string'
              ? filter.value
              : String(filter.value || '');

          return {
            ...filter,
            platformSlug,
            valueLowerCase: valueString.toLowerCase(),
            criteria: criteriaObj?.value,
          } as GroupedFilters;
        } catch (error) {
          return null;
        }
      })
      .filter((filter) => filter !== null) as GroupedFilters[];
  }, [appliedFilters]);

  return appliedFiltersGrouped;
};

export { useGroupFilters };
